import { TriggerCreate } from "@dots-projects/types";
import { v4 as uuidv4 } from "uuid";
import gif from "./feedback.gif";

export const collectFeedback = (
  workspace: string
): {
  trigger: TriggerCreate;
  gif: any;
  title: string;
  description: string;
} => {
  return {
    title: "Collect Feedback",
    description:
      "<p>Improve your community by listening to members! In this template Dots will add a button that allows users to write their feedback.</p>",
    gif,
    trigger: {
      name: "Collect Feedback",
      type: "button_click",
      platform: "discord",
      communityId: localStorage.getItem("guild-id") || "",
      authorUserId: localStorage.getItem("discord-id") || "",
      workspace,
      isDraft: true,
      configs: {
        messages: [
          {
            id: uuidv4(),
            buttonIds: [uuidv4()],
          },
        ],
        skipDefer: true,
        responseOnError: "Something went wrong, please try again!",
        responseOnComplete: "",
        $$editorButtonClickContent: {
          message: "Click below to send us your feedback!",
          channelId: "1075908920138289285",
          buttonText: "Send feedback",
          buttonEmoji: "📝",
          htmlMessage: "<p>Click below to send us your feedback!</p>",
        },
      },
      steps: [
        {
          id: "open_modal-0-y7O2nR",
          type: "open_modal",
          configs: {
            title: "Feedback",
            fields: [
              {
                id: "field",
                type: "open_modal",
                label: "Do you have any feedback for us?",
                style: "short",
              },
            ],
          },
          isEntry: false,
          isGoal: false,
          name: "Show a modal",
          transitions: [
            {
              targetStepId: "send_message-0-X_-HGB",
              when: {
                userResponse: {
                  type: "modal-submit",
                  userId: "{{user.id}}",
                  modalId: "{{open_modal-0-y7O2nR.modalId}}",
                },
              },
            },
          ],
        },
        {
          id: "send_message-0-X_-HGB",
          type: "send_message",
          configs: {
            message:
              "Thank you for your time <@{{user.id}}>! Your feedback helps us to improve ﻿🙌",
            channelId: "{{interaction.channelId}}",
            ephemeral: true,
            delaySeconds: 0,
            removeUrlEmbeds: false,
            $$editorHtmlMessage:
              '<p>Thank you for your time <span class="mention" data-index="0" data-id="<@user.id>" data-denotation-char="{{" data-value="@username}}">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">{{</span>@username}}</span>﻿</span>! Your feedback helps us to improve <span class="ql-emojiblot" data-name="raised_hands">﻿<span contenteditable="false"><span class="ap ap-raised_hands">🙌</span></span>﻿</span></p>',
            sendBrandingIfNotPremium: false,
          },
          isEntry: false,
          isGoal: false,
          name: "Send a message",
          transitions: [],
        },
      ],
    },
  };
};
